/* @flow */

import * as React from 'react'
import styled from 'styled-components'
import FullscreenOverlay from 'app/components/presentational/FullscreenOverlay'
import Icon from 'app/components/presentational/Icon'
import ResponsiveImage from 'app/components/presentational/ResponsiveImage'
import media from 'app/styles/media'

// TODO INCONTENT-1261:
// - Make sure; images fit to fill full screen width, while height can be larger than viewport.
const FullViewportContent = styled.div`
    width: 100%;
    height: 100%;

    display: flex;

    align-items: center;
    justify-content: center;
`

const FullViewportImageContainer = styled.div`
    position: relative;
    padding: 20px;

    ${media.desktop`
        height: 100vh;
    `};
`

const FullViewportImageElement = styled.div`
    background-color: #fff;
`

const FullViewportCloseButton = styled.div`
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 1; /* trigger positioning on top of image */

    cursor: pointer;
    background-color: #203049;
    border-radius: 50%;
`

class FullViewportImage extends React.Component<{ imageSrc: string }, { visible: boolean }> {
    // eslint-disable-next-line react/sort-comp
    props: {
        imageSrc: string,
    }

    state = {
        visible: true,
    }
    /* eslint-disable camelcase */
    UNSAFE_componentWillReceiveProps() {
        this.setState({ visible: true })
    }

    onCloseClick = () => {
        this.setState({ visible: false })
    }

    onImageClick = (e: SyntheticEvent<>) => {
        e.stopPropagation()
    }

    render() {
        const { imageSrc } = this.props
        const { visible } = this.state
        const { onCloseClick } = this

        if (!visible) {
            return null
        }

        return (
            <div onClick={onCloseClick}>
                <FullscreenOverlay transparent>
                    <FullViewportContent>
                        <FullViewportCloseButton>
                            <Icon type="crossRound" size="larger" color="white" hoverColor="darkGrey" />
                        </FullViewportCloseButton>
                        <FullViewportImageContainer>
                            <FullViewportImageElement onClick={this.onImageClick}>
                                <ResponsiveImage src={imageSrc} />
                            </FullViewportImageElement>
                        </FullViewportImageContainer>
                    </FullViewportContent>
                </FullscreenOverlay>
            </div>
        )
    }
}

export default FullViewportImage
